<ng-template #buttons>
    <!--functionality is not complete-->
    <!--    @if (store.isAllowed('administration.read')()) {-->
    <!--        <app-button-->
    <!--            icon="pi-external-link"-->
    <!--            severity="secondary"-->
    <!--            label="database.servicesAdministrationPage.export"-->
    <!--        ></app-button>-->
    <!--    }-->
</ng-template>

<app-table
    #serviceTable
    translatePrefix="database.servicesAdministrationPage.servicesList."
    [columns]="columns"
    [buttons]="buttons"
    resource="service"
    [showButtonLabels]="true"
    [gridData]="$any(store.services())"
    [refreshCallback]="store.api.getServices"
    (createCallback)="createService()"
    (detailCallback)="detailService($event)"
    (deleteCallbackWithEvent)="deleteService($event)"
    [additionalFilter]="additionalFilter()"
    [hideCheckboxes]="true"
></app-table>
